angular.module 'zc.projects.reports', [
  'zc.projects'
  'zc.projects.campaigns'
  'zc.commonApi'
]





// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.reports/index.js.coffee